import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import PopularGamesSection from './components/PopularGamesSection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'PG模拟器 - 免费在线体验PG游戏模拟平台',
    description: 'PG模拟器是专为游戏爱好者打造的在线模拟体验平台，无需下载即可免费试玩PG系列游戏。支持多设备运行，画面流畅，操作简单。',
    url: 'https://www.pg-simulator.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: 'PG模拟器',
      url: 'https://www.pg-simulator.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <PopularGamesSection />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}